export default __webpack_public_path__ + "static/media/glrc-course.cookies-and-custards.8e0a4689.png";